var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 3.33333H15C15.6426 3.33333 16.1667 3.85742 16.1667 4.5V13.8333C16.1667 14.4759 15.6426 15 15 15H5.66667C5.02409 15 4.5 14.4759 4.5 13.8333V12.6667M11.5 12.6667H2.16667C1.52409 12.6667 1 12.1426 1 11.5V2.16667C1 1.52409 1.52409 1 2.16667 1H11.5C12.1426 1 12.6667 1.52409 12.6667 2.16667V11.5C12.6667 12.1426 12.1426 12.6667 11.5 12.6667Z",
    stroke: "#8698A5",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.52f73ddad18cebce5cbb1b730cb1fe50.svg";
export { ForwardRef as ReactComponent };